import { jsx as _jsx } from "react/jsx-runtime";
import GestureTitle from './gestureTitle';
import GormalTitle from './normalTitle';

var CustomTitle = function CustomTitle(props) {
  var titleType = props.config.titleType;
  return titleType === 'btnTitle' ? _jsx(GestureTitle, Object.assign({}, props)) : _jsx(GormalTitle, Object.assign({}, props));
};

CustomTitle.defaultProps = {
  config: {}
};
CustomTitle.displayName = 'CustomTitle';
export default CustomTitle;